export const PROVIDERS_CREATE = 'PROVIDERS_CREATE';
export const PROVIDERS_CREATE_PENDING = 'PROVIDERS_CREATE_PENDING';
export const PROVIDERS_CREATE_FULFILLED = 'PROVIDERS_CREATE_FULFILLED';
export const PROVIDERS_CREATE_REJECTED = 'PROVIDERS_CREATE_REJECTED';

export const PROVIDERS_GET = 'PROVIDERS_GET';
export const PROVIDERS_GET_PENDING = 'PROVIDERS_GET_PENDING';
export const PROVIDERS_GET_FULFILLED = 'PROVIDERS_GET_FULFILLED';
export const PROVIDERS_GET_REJECTED = 'PROVIDERS_GET_REJECTED';

export const PROVIDER_UPDATE = 'PROVIDER_UPDATE';
export const PROVIDER_UPDATE_PENDING = 'PROVIDER_UPDATE_PENDING';
export const PROVIDER_UPDATE_FULFILLED = 'PROVIDER_UPDATE_FULFILLED';
export const PROVIDER_UPDATE_REJECTED = 'PROVIDER_UPDATE_REJECTED';

export const DELETE_PROVIDER = 'DELETE_PROVIDER';
export const DELETE_PROVIDER_PENDING = 'DELETE_PROVIDER_PENDING';
export const DELETE_PROVIDER_FULFILLED = 'DELETE_PROVIDER_FULFILLED';
export const DELETE_PROVIDER_REJECTED = 'DELETE_PROVIDER_REJECTED';

export const PROVIDER_DOWNLOAD_REPORT = 'PROVIDER_DOWNLOAD_REPORT';
export const PROVIDER_DOWNLOAD_REPORT_PENDING = 'PROVIDER_DOWNLOAD_REPORT_PENDING';
export const PROVIDER_DOWNLOAD_REPORT_FULFILLED = 'PROVIDER_DOWNLOAD_REPORT_FULFILLED';
export const PROVIDER_DOWNLOAD_REPORT_REJECTED = 'PROVIDER_DOWNLOAD_REPORT_REJECTED';

export const PROVIDER_UPLOAD_FILE = 'PROVIDER_UPLOAD_FILE';
export const PROVIDER_UPLOAD_FILE_PENDING = 'PROVIDER_UPLOAD_FILE_PENDING';
export const PROVIDER_UPLOAD_FILE_FULFILLED = 'PROVIDER_UPLOAD_FILE_FULFILLED';
export const PROVIDER_UPLOAD_FILE_REJECTED = 'PROVIDER_UPLOAD_FILE_REJECTED';

export const PROVIDER_STATUS_UPDATE = 'PROVIDER_STATUS_UPDATE';
export const PROVIDER_STATUS_UPDATE_PENDING = 'PROVIDER_STATUS_UPDATE_PENDING';
export const PROVIDER_STATUS_UPDATE_FULFILLED = 'PROVIDER_STATUS_UPDATE_FULFILLED';
export const PROVIDER_STATUS_UPDATE_REJECTED = 'PROVIDER_STATUS_UPDATE_REJECTED';

export const PROVIDER_SEARCH_FROM_NPI = 'PROVIDER_SEARCH_FROM_NPI';
export const PROVIDER_SEARCH_FROM_NPI_PENDING = 'PROVIDER_SEARCH_FROM_NPI_PENDING';
export const PROVIDER_SEARCH_FROM_NPI_FULFILLED = 'PROVIDER_SEARCH_FROM_NPI_FULFILLED';
export const PROVIDER_SEARCH_FROM_NPI_REJECTED = 'PROVIDER_SEARCH_FROM_NPI_REJECTED';

export const PROVIDER_UPDATE_NPI_ROLE = 'PROVIDER_UPDATE_NPI_ROLE';
export const PROVIDER_UPDATE_NPI_ROLE_PENDING = 'PROVIDER_UPDATE_NPI_ROLE_PENDING';
export const PROVIDER_UPDATE_NPI_ROLE_FULFILLED = 'PROVIDER_UPDATE_NPI_ROLE_FULFILLED';
export const PROVIDER_UPDATE_NPI_ROLE_REJECTED = 'PROVIDER_UPDATE_NPI_ROLE_REJECTED';


export const createProvider = (data, callback) => (  {
    type: PROVIDERS_CREATE,
    payload: { data, callback },
});

export const get = (familyId) => ({
    type: PROVIDERS_GET,
    payload: { familyId },
});

export const updateProvider = (data, callback) => ({
    type: PROVIDER_UPDATE,
    payload: { data, callback },
});

export const deleteProvider = (providerId, callback) => ({
    type: DELETE_PROVIDER,
    payload: { providerId, callback }
});

export const download = (payload, callback) => ({
    type: PROVIDER_DOWNLOAD_REPORT,
    payload: { payload, callback }
});

export const uploadFile = (csvData, callback) => ({
    type: PROVIDER_UPLOAD_FILE,
    payload: { csvData, callback }
});

export const updateEnableStatus = (payload, callback, isCriteria, enable) => ({
    type: PROVIDER_STATUS_UPDATE,
    payload: { payload, callback, isCriteria, enable }
});

export const searchFromNPI = (npi, callback) => ({
    type: PROVIDER_SEARCH_FROM_NPI,
    payload: { npi, callback },
});

export const updateProviderNPIRole = (data, callback) => ({
    type: PROVIDER_UPDATE_NPI_ROLE,
    payload: { data, callback },
});